import $ from 'jquery';
import { isMobile, ActiveLanguage } from 'shared/vidio_helpers';
import LocationAdapter from 'shared/location_adapter';

const mobileEmailConfirmationView = require('templates/mobile/email_confirmation_modal.jst.jade')
const desktopEmailConfirmationView = require('templates/desktop/email_confirmation_modal.jst.jade')

export default class EmailConfirmationModal {
  constructor() {
    const lang = ActiveLanguage.get();
    this.$modal = null;
    this.data = { locale: window.Locale[lang].email_confirmation_modal };
    this.location = new LocationAdapter();
  }

  init() {
    this.renderModal();
    this.initElements();
    this.initCloseModalHandler();
    this.initResendHandler();
  }

  renderModal() {
    if (isMobile()) {
      this.$modal = $(mobileEmailConfirmationView(this.data));
    } else {
      this.$modal = $(desktopEmailConfirmationView(this.data));
    }
    $('body').append(this.$modal);
  }

  initElements() {
    this.$overlay = this.$modal.find('.email-confirmation-modal__overlay');
    this.$closeButton = this.$modal.find('.email-confirmation-modal__close');
    this.$okButton = this.$modal.find('.email-confirmation-modal__form-button');
    this.$emailDestination = this.$modal.find('.email-confirmation-modal__description--email_destination');
    this.$emailResend = this.$modal.find('.email-confirmation-modal__resend');
    this.$emailConfirmationSection = this.$modal.find('.email-confirmation-modal__section');
  }

  initCloseModalHandler() {
    this.$overlay.on('click', this.closeModal.bind(this));
    this.$closeButton.on('click', this.closeModal.bind(this));
    this.$okButton.on('click', this.closeModal.bind(this));
  }

  initResendHandler() {
    if(this.$emailResend) {
      this.$emailResend.on('click', function() {
        this.clickVerifyButton();
      }.bind(this));
    }
  }

  clickVerifyButton() {
    let verifyButton = $('#email_verify_button');
    verifyButton.click();
  }

  showEmailConfirmationSection(currentEmail){
    this.showElement(this.$emailConfirmationSection);
    this.$emailDestination.html(currentEmail);
  }

  closeModal() {
    const urlParams = new URLSearchParams(this.location.search);
    const userReturnTo = urlParams.get('user_return_to');

    if (userReturnTo) {
      LocationAdapter.href(userReturnTo);
    } else {
      this.removeEscapeKeyEvent();
      this.hideElement(this.$modal);
    }
  }

  showElement($el) {
    $el.removeClass('hide');
  }

  hideElement($el) {
    $el.addClass('hide');
  }

  getEscapeKeyFunction(){
    if(this.escapeKeyFunction == undefined) this.escapeKeyFunction = this.onEscapeKey.bind(this);
    return this.escapeKeyFunction;
  }

  addEscapeKeyEvent(){
    $('body').on('keydown', this.getEscapeKeyFunction());
  }

  removeEscapeKeyEvent(){
    $('body').off('keydown', this.getEscapeKeyFunction());
  }

  onEscapeKey(e){
    if(e.key == 'Escape' || e.key == 'Esc')
      this.closeModal();
  }
}
